//React lib
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
//internal lib
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { persistor, store } from "./store/store";
import "./index.css";
import "./assets/styles/themeGlobalArt.scss";
import "./assets/styles/themeCrico.scss";
import "./assets/styles/themeSip.scss";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const updateApp = (waitingWorker: any) => {
  // Send a message to the service worker to skip the waiting phase
  waitingWorker.postMessage({ type: "SKIP_WAITING" });

  // Reload the page to get the new content (soft reload)
  // The old caches are deleted and the new version is fetched
  // window.localStorage.clear();
  setInterval(() => {
    window.location.reload();
  }, 10000);
};

// Service worker state check
serviceWorkerRegistration.register({
  onUpdate: (registration: any) => {
    // This callback is triggered when a new service worker is available
    // and is in the 'waiting' state.
    if (registration.waiting) {
      // You now know a new version is available.
      // Trigger your UI to show the refresh button.
      // For example, set a state variable in a React component.
      // alert('New content available! Please refresh for new version.');
      updateApp(registration.waiting);
      // createRefreshBtn(registration.waiting);
      // You might want to store 'registration' to use its 'waiting' property later.
    }
  },
});

const programName = process.env.REACT_APP_PRODUCT_CODE;
const body = document.body;
programName === "ga"
  ? body.classList.add("theme-ga")
  : programName === "crico"
  ? body.classList.add("theme-crico")
  : body.classList.add("theme-sa");

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change.
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
